<template>
	<div>
		<div class="row">
			<div class="col text-center">
				<h1><span style="color: #5df286; text-shadow: 0 0 20px #5df286">Live</span> <span style="color: #eb5dff; text-shadow: 0 0 20px #eb5dff">Joiner</span></h1>
			</div>
		</div>
		<b-breadcrumb>
			<b-breadcrumb-item href="/">LiveJoiner</b-breadcrumb-item>
			<b-breadcrumb-item active>Voices</b-breadcrumb-item>
		</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-input v-model="q" placeholder="Search..." @input="loadVoices()" class="mb-2"></b-input>
		<b-table small striped hover :items="voices" :busy="loading>0" :fields="['voice','provider','command']">
			<template #cell(voice)="data">
				{{data.item.description||data.item.name}}<br />
				<small>{{data.item.language}} {{data.item.age}} {{data.item.sex}}</small>
			</template>
			<template #cell(provider)="data">
				{{data.item.provider}}<br />
				<small>{{data.item.type}}</small>
			</template>
			<template #cell(command)="data">
				<a href="#" v-b-tooltip.hover.left.v-primary title="Copy to clipboard" @click="copyAndToast(`!voice ${data.item.selector}`, 'Command copied to clipboard, you can now paste it in chat.')"><b-icon icon="clipboard"></b-icon></a> <code v-if="data.item.selector">!voice {{data.item.selector}}</code><br />
				<a href="#" v-b-tooltip.hover.left.v-primary title="Copy to clipboard" @click="copyAndToast(`!voice ${data.item.unique_id}`, 'Command copied to clipboard, you can now paste it in chat.')"><b-icon icon="clipboard"></b-icon></a> <code v-if="data.item.unique_id">!voice {{data.item.unique_id}}</code>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';
export default {
	components: {
		Pager,
	},
	data: function() { return {
		plan: null,
		voices: null,
		loading: 0,
		error: null,
		total: 0,
		skip: 0,
		perPage: 10,
		q: undefined,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip || 0)||0;
		this.limit = parseInt(this.$route.query.limit || 0)||10;
		this.plan = this.$route.params && this.$route.params.plan || null;
		this.loadUserVoices();
	},
	watch: {
		'$route': 'loadUserVoices',
		'q': 'loadUserVoices',
	},
	methods: {
		async loadUserVoices() {
			this.loading++;
			try {
				const result = await this.$api.get(`publicVoices`, { q: this.q||'', limit: this.perPage, skip: this.skip, plan: this.plan });
				this.voices = result.results;
				this.total = result.total;
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ path: `/`, query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage } });
		},
		copyAndToast(string, message, dropdown) {
			let target;
			if(dropdown) {
				target = dropdown.target;
				while(target.nodeName != 'DIV')
					target = target.parentNode;
			}
			this.$util.copyToClipboard(string, target);
			this.$bvToast.toast(message, { title: 'Success', variant: 'success', solid: true });
			console.log('copyAndToast', string, message, dropdown);
		},
	},
}
</script>
